import { gql } from '@apollo/client';

export const PROVISION_REVUE = gql`
  mutation ProvisionRevue($input: ProvisionRevueInput!) {
    provisionRevue(input: $input) {
      revueCompanyId
      status
    }
  }
`;

export interface ProvisionRevueInput {
  companyName: string;
  email: string;
  firstName: string;
  lastName: string;
  /** Initial password for the Revue user (≥8 chars). scio3 forwards it to ads-portal; never persisted on scio3. */
  password: string;
}

export interface ProvisionRevueVariables {
  input: ProvisionRevueInput;
}

export interface ProvisionRevueResponse {
  revueCompanyId: string;
  status: string;
}

export interface ProvisionRevueResult {
  provisionRevue: ProvisionRevueResponse;
}
